module.exports = __webpack_public_path__ + "img/message-sharp-light.d3fa2a5e.svg";